class ProductSliderAnimation {
  constructor(container) {
    this.container = container;
    this.images = null;
    this.interval = null;
    this.activeIndex = 0;

    // console.log('####images', this.images);
    this.addEventListeners();
  }

  addEventListeners() {
    if (!this.container) return;

    $(document).on('mousedown', this.container, (e) => {
      const box = $(this.container);

      e.preventDefault();
      box.parent().removeClass('is--moved');
      let moved = false;
      let x = e.clientX;
      let delta = 0;

      const onMouseMove = (event) => {
        let move = Math.round((event.clientX - x) / 10);

        if (move < delta) {
          this.move('left');
          delta = move;
        } else if (move > delta) {
          this.move('right');
          delta = move;
        }

        moved = true;
        box.parent().addClass('is--moved');
      }

      box.on('mousemove', onMouseMove);

      box.on('mouseup', () => {
        box.off('mousemove', onMouseMove);
        this.start();
      })

      this.stop();
    })
  }

  initImages(images) {
    this.images = $(images);
  }

  start() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    // const images = $(this.images);
    // const imgs = $(this.images);

    this.interval = setInterval(() => {
      // console.log('###timer', this.activeIndex);
      this.images.removeClass('is--visible');
      this.images.eq(this.activeIndex).addClass('is--visible');

      if (this.activeIndex >= this.images.length - 1) {
        this.activeIndex = 0;
      } else {
        this.activeIndex++;
      }
    }, 100)
  }

  stop() {
    clearInterval(this.interval);
    this.interval = null;
  }

  reset() {
    this.activeIndex = 0;
  }

  move(direction) {
    if (direction === 'left') {
      this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : this.images.length - 1;
    }

    if (direction === 'right') {
      this.activeIndex = this.activeIndex < this.images.length - 1 ? this.activeIndex + 1 : 0;
    }

    this.images.removeClass('is--visible');
    this.images.eq(this.activeIndex).addClass('is--visible');
  }
}
